<template>
  <div>
    <Modal
      class="editBlock"
      v-model="modal"
      title="添加新标签"
      width="30"
      footer-hide
    >
      <div class="bodyhigh">
        <div class="title">连系人标签</div>
        <div class="bodytwice">
          <div class="content">
            <Row>
              <Col offset="1"  span="12">
                <label>标签名称</label>
                <Input class="editInput account" v-model="labelname" type="text"></Input>
              </Col>
            </Row>
            <div class="bodytwice-bottom">
              <Row class="bgcContent">
                <Col offset="1" span="3">
                  <label>背景颜色</label>
                </Col>
                <Col span="20">
                  <div class="bgcBlock" style="background-color:#377fed" @click="backgroundColor = '#377fed';addBorder(0)"></div>
                  <div class="bgcBlock" style="background-color:#67caff" @click="backgroundColor = '#67caff';addBorder(1)"></div>
                  <div class="bgcBlock" style="background-color:#8e8e8e" @click="backgroundColor = '#8e8e8e';addBorder(2)"></div>
                  <div class="bgcBlock" style="background-color:#32c24d" @click="backgroundColor = '#32c24d';addBorder(3)"></div>
                  <div class="bgcBlock" style="background-color:#e45db3" @click="backgroundColor = '#e45db3';addBorder(4)"></div>
                  <div class="bgcBlock" style="background-color:#ff626f" @click="backgroundColor = '#ff626f';addBorder(5)"></div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div class="btn" @click="addConfirm">提交</div>
          <div class="btn" @click="reset">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "ModalLabelForm",
  props: ["addStatus","labelObj"],
  data () {
    return {
      labelname: '',
      backgroundColor: '',
    }
  },
  computed: {
    ...mapGetters(['username']),
    modal: {
      get () {
        return this.addStatus
      },
      set (val) {
        this.reset()
        this.$emit("update:addStatus", val)
      }
    }
  },
  methods: {
    //提交确定 
    addConfirm () {
      this.$axios.changememlabel({labelname:this.labelname,type:"1",color:this.backgroundColor})
      .then(res => {
        if(res.status == 1){
          this.$emit("getlabel")
        }
      })
      .catch(err => console.error(err))
      this.modal = false
    },
    //reset
    reset () {
      this.labelname = ''
      this.backgroundColor = ''
      let obj = document.getElementsByClassName("bgcBlock")
      for(let i = 0; i<obj.length; i++){
        obj[i].style.border = "none"
      }

    },
    addBorder(val){
      let obj = document.getElementsByClassName("bgcBlock")
      for(let i = 0; i<obj.length; i++){
        obj[i].style.border = "none"
      }
      obj[val].style.border = "solid 2px #2462bf"
    }
  }
}
</script>
<style lang="less">
.bgcBlock{
  width: 45px;
  height: 45px;
  border-radius: 3px;
  display: inline-block;
  margin-left: 5px;
  margin-top: -13px;
  cursor: pointer;
}
.bgcContent{
  margin-top: 20px;
}
</style>